import { ECountryTrads } from "common/enums/trads/ECountryTrads";
import { ENationalityTrads } from "common/enums/trads/ENationalityTrads";
import {
	EAssociationProfesionnelleTrads,
	EAutreCgpCorporationGroupsTrads,
	EAutreCgpGroupsTrads,
	ECategorieSocialProfessionnelTrads,
	ECivilityTrads,
	ECommunityInvestmentTooltipTrads,
	ECommunityInvestmentTrads,
	EConnaissanceExperienceCorporationGroupsTrads,
	EConnaissanceExperienceGroupsTrads,
	ECorporationFormeJuridiqueTrads,
	ECorporationRegimeFiscalTrads,
	ECorporationResidenceFiscaleTrads,
	EDistributionFrequencyTrads,
	EEtatCompteTrads,
	EFinanceDurableCorporationGroupsTrads,
	EFinanceDurableGroupsTrads,
	EFinancialObjectiveTrads,
	EFormeJuridiqueTrads,
	EFundsOriginCommunityInvestmentTrads,
	EFundsOriginCorporationTrads,
	EFundsOriginTrads,
	EHabilitationTrads,
	EInvestorInvitationStatusTrads,
	ELegalCapacityTrads,
	ELegalStatusTrads,
	ELigneMetierTrads,
	EMaritalStatusTrads,
	EMatrimonialRegimeTrads,
	EOtherErrorsTrads,
	EPatrimoineRevenusCorporationGroupsTrads,
	EPatrimoineRevenusGroupsTrads,
	EPaymentMethodTrads,
	ESubscriptionProductTypeTrads,
	EProductCategoriesTrads,
	EProductDocumentTypeTrads,
	EProductFileTypeTrads,
	EProductTypeTrads,
	EQualiteRepresentantTrads,
	ESubCategorisationMifCorporationTrads,
	ESubChargeAnnuelleFoyerFiscalTrads,
	ESubCombienTempsRealisezInvestissementsCorporationTrads,
	ESubCombienTempsRealisezInvestissementsTrads,
	ESubCommentConnuConsultimCorporationTrads,
	ESubCommentConnuConsultimTrads,
	ESubConnaissancesMarcheFinancierProduitsEpargneCorporationTrads,
	ESubConnaissancesMarcheFinancierProduitsEpargneTooltipTrads,
	ESubConnaissancesMarcheFinancierProduitsEpargneTrads,
	ESubConnaissancesMarcheImmobilierCorporationTrads,
	ESubConnaissancesMarcheImmobilierTooltipTrads,
	ESubConnaissancesMarcheImmobilierTrads,
	ESubDejaSouscritCombienCorporationTrads,
	ESubDejaSouscritPartCorporationTrads,
	ESubDejaSouscritQuandCorporationTrads,
	ESubDejaSouscritScpiPartPiervalCorporationTrads,
	ESubDejaSouscritScpiPartPiervalTrads,
	ESubDejaSouscritTypeCorporationTrads,
	ESubFilesTypesTrads,
	ESubFiscaliteApplicableScpiCorporationTrads,
	ESubFiscaliteApplicableScpiTrads,
	ESubFrequenceTransactionCorporationTrads,
	ESubHorizonInvestissementCorporationTrads,
	ESubHorizonInvestissementTrads,
	ESubInvestissementPatrimoineGlobalTrads,
	ESubModeEntreeRelationCorporationTrads,
	ESubModeEntreeRelationTrads,
	ESubModeGestionUtiliseCorporationTrads,
	ESubModeGestionUtiliseTrads,
	ESubMoyenneTransactionCorporationTrads,
	ESubNbOperationsDerniersMoisTrads,
	ESubNbOperationsSansConseillerCorporationTrads,
	ESubOriginePatrimoineCorporationTrads,
	ESubPartInvestissementPatrimoineGlobalCorporationTrads,
	ESubPartInvestissementsDurablesCorporationTrads,
	ESubPartInvestissementsDurablesTrads,
	ESubPerformanceScpiFonctionCorporationTrads,
	ESubPerformanceScpiFonctionTrads,
	ESubPeriodicitePiervalCorporationTrads,
	ESubPlacementPeuLiquiditeCorporationTrads,
	ESubPreferenceDurabiliteCorporationTooltipTrads,
	ESubPreferenceDurabiliteCorporationTrads,
	ESubPreferenceDurabiliteTooltipTrads,
	ESubPreferenceDurabiliteTrads,
	ESubReactionChuteBrusqueValeurInvestissementCorporationTrads,
	ESubReactionChuteBrusqueValeurInvestissementTrads,
	ESubRisqueRendementAccepterTrads,
	ESubRisqueRendementCorporationTrads,
	ESubScpiImpacteesParCorporationTrads,
	ESubScpiImpacteesParTrads,
	ESubScpiOpciFrequenceTransactionTrads,
	ESubScpiOpciMoyenneTransactionCoutTrads,
	ESubScpiOpciNombreSouscriptionsTrads,
	ESubScpiRecourtCreditCorporationTrads,
	ESubScpiRecourtCreditTrads,
	ESubscriptionTypeTrads,
	ESubSituationPatrimonialeTrads,
	ESubStatutFactaCrsCorporationTrads,
	ESubStepCGPTrads,
	ESubStepMOTrads,
	ESubSupportPlacementCorporationTrads,
	ESubSupportPlacementTrads,
	ESubTrancheMarginaleImpositionTrads,
	ETestAdequationCorporationGroupsTrads,
	ETestAdequationGroupsTrads,
	ETypeConseillerTrads,
	ETypePersonneJuridiqueTrads,
	EValidationErrorTrads,
} from "common/enums/trads/index";
import { EProductInformation } from "components/pages/Products/Product/elements/ProductInformation";
import { ESteps } from "components/pages/Subscriptions/corporation/CreateCorporation";
const ECorporationStepsTrads: Record<ESteps, string> = {
	CORPORATION_INFO: "Informations société",
	LEGAL_REPRESENTATIVE: "Représentant légal",
	BENEFICIARIES: "Bénéficiaires effectifs",
};
const EProductInformationTrads: Record<EProductInformation, string> = {
	name: "Nom du produit",
	price: "Prix de part",
	category: "Catégorie",
	minNumberOfShares: "Minimum de parts (à la première souscription)",
	subFees: "Frais de souscription",
	dueDate: "Délai de jouissance",
	withdrawalPrice: "Prix de retrait",
	distributionRate: "Taux de distribution {{year}}",
	distributionRateNet: "Taux de distribution net",
	distributionRateN2: "Taux de distribution {{year}}",
	distributionFrequency: "Fréquence de distribution",
	capitalization: "Capitalisation",
	financialOccupancyRate: "Taux d'occupation financier",
	retainedEarnings: "Report à nouveau",
	ifiDate: "Date de valorisation IFI",
	ifiValue: "Valeur IFI",
	avantageFiscal: "Avantage fiscal",
	droitsEntree: "Droits d'entrée",
	eligiblePea: "Éligible PEA",
	eligible150_0BTer: "Éligible 150-0 B ter",
};

const translations = {
	EPaymentMethod: EPaymentMethodTrads,
	ESubscriptionProductType: ESubscriptionProductTypeTrads,
	ESubSituationPatrimoniale: ESubSituationPatrimonialeTrads,
	ESubTrancheMarginaleImposition: ESubTrancheMarginaleImpositionTrads,
	ESubInvestissementPatrimoineGlobal: ESubInvestissementPatrimoineGlobalTrads,
	ESubPartInvestissementPatrimoineGlobalCorporation: ESubPartInvestissementPatrimoineGlobalCorporationTrads,
	ESubChargeAnnuelleFoyerFiscal: ESubChargeAnnuelleFoyerFiscalTrads,
	EFinancialObjective: EFinancialObjectiveTrads,
	EFundsOrigin: EFundsOriginTrads,
	ESubModeGestionUtilise: ESubModeGestionUtiliseTrads,
	ESubRisqueRendementAccepter: ESubRisqueRendementAccepterTrads,
	ESubScpiOpciNombreSouscriptions: ESubScpiOpciNombreSouscriptionsTrads,
	ESubScpiOpciFrequenceTransaction: ESubScpiOpciFrequenceTransactionTrads,
	ESubScpiOpciMoyenneTransactionCout: ESubScpiOpciMoyenneTransactionCoutTrads,
	ESubConnaissancesMarcheFinancierProduitsEpargne: ESubConnaissancesMarcheFinancierProduitsEpargneTrads,
	ESubConnaissancesMarcheFinancierProduitsEpargneTooltip: ESubConnaissancesMarcheFinancierProduitsEpargneTooltipTrads,
	ESubCombienTempsRealisezInvestissements: ESubCombienTempsRealisezInvestissementsTrads,
	ESubConnaissancesMarcheImmobilier: ESubConnaissancesMarcheImmobilierTrads,
	ESubConnaissancesMarcheImmobilierTooltip: ESubConnaissancesMarcheImmobilierTooltipTrads,
	ESubReactionChuteBrusqueValeurInvestissement: ESubReactionChuteBrusqueValeurInvestissementTrads,
	ECivility: ECivilityTrads,
	EMaritalStatus: EMaritalStatusTrads,
	ELegalCapacity: ELegalCapacityTrads,
	EMatrimonialRegime: EMatrimonialRegimeTrads,
	ESubHorizonInvestissement: ESubHorizonInvestissementTrads,
	ESubHorizonInvestissementCorporation: ESubHorizonInvestissementCorporationTrads,
	ESubPartInvestissementsDurables: ESubPartInvestissementsDurablesTrads,
	ESubPartInvestissementsDurablesCorporation: ESubPartInvestissementsDurablesCorporationTrads,
	ESubPreferenceDurabilite: ESubPreferenceDurabiliteTrads,
	ESubPreferenceDurabiliteCorporation: ESubPreferenceDurabiliteCorporationTrads,
	ESubPreferenceDurabiliteTooltip: ESubPreferenceDurabiliteTooltipTrads,
	ESubPreferenceDurabiliteCorporationTooltip: ESubPreferenceDurabiliteCorporationTooltipTrads,
	ESubModeEntreeRelation: ESubModeEntreeRelationTrads,
	ESubModeEntreeRelationCorporation: ESubModeEntreeRelationCorporationTrads,
	ESubStepMO: ESubStepMOTrads,
	ESubStepCGP: ESubStepCGPTrads,
	ECountry: ECountryTrads,
	ENationality: ENationalityTrads,
	EValidationErrors: EValidationErrorTrads,
	ETypeConseiller: ETypeConseillerTrads,
	EHabilitation: EHabilitationTrads,
	ELigneMetier: ELigneMetierTrads,
	EEtatCompte: EEtatCompteTrads,
	EFormeJuridique: EFormeJuridiqueTrads,
	EAssociationProfesionnelle: EAssociationProfesionnelleTrads,
	ESubCommentConnuConsultim: ESubCommentConnuConsultimTrads,
	ESubCommentConnuConsultimCorporation: ESubCommentConnuConsultimCorporationTrads,
	ESubNbOperationsDerniersMois: ESubNbOperationsDerniersMoisTrads,
	ESubPerformanceScpiFonction: ESubPerformanceScpiFonctionTrads,
	ESubPerformanceScpiFonctionCorporation: ESubPerformanceScpiFonctionCorporationTrads,
	ESubScpiRecourtCredit: ESubScpiRecourtCreditTrads,
	ESubScpiRecourtCreditCorporation: ESubScpiRecourtCreditCorporationTrads,
	ESubScpiImpacteesPar: ESubScpiImpacteesParTrads,
	ESubScpiImpacteesParCorporation: ESubScpiImpacteesParCorporationTrads,
	ESubFiscaliteApplicableScpi: ESubFiscaliteApplicableScpiTrads,
	ESubFiscaliteApplicableScpiCorporation: ESubFiscaliteApplicableScpiCorporationTrads,
	EProductCategories: EProductCategoriesTrads,
	EProductType: EProductTypeTrads,
	ETestAdequationGroups: ETestAdequationGroupsTrads,
	ETestAdequationCorporationGroups: ETestAdequationCorporationGroupsTrads,
	EPatrimoineRevenusGroups: EPatrimoineRevenusGroupsTrads,
	EPatrimoineRevenusCorporationGroups: EPatrimoineRevenusCorporationGroupsTrads,
	EFinanceDurableGroups: EFinanceDurableGroupsTrads,
	EFinanceDurableCorporationGroups: EFinanceDurableCorporationGroupsTrads,
	EConnaissanceExperienceGroups: EConnaissanceExperienceGroupsTrads,
	EConnaissanceExperienceCorporationGroups: EConnaissanceExperienceCorporationGroupsTrads,
	EAutreCgpGroups: EAutreCgpGroupsTrads,
	EAutreCgpCorporationGroups: EAutreCgpCorporationGroupsTrads,
	ESubFilesTypes: ESubFilesTypesTrads,
	EOtherErrors: EOtherErrorsTrads,
	EDistributionFrequency: EDistributionFrequencyTrads,
	ECommunityInvestment: ECommunityInvestmentTrads,
	ECommunityInvestmentTooltip: ECommunityInvestmentTooltipTrads,
	ELegalStatus: ELegalStatusTrads,
	ECorporationSteps: ECorporationStepsTrads,
	ECorporationRegimeFiscal: ECorporationRegimeFiscalTrads,
	ECorporationResidenceFiscale: ECorporationResidenceFiscaleTrads,
	ECorporationFormeJuridique: ECorporationFormeJuridiqueTrads,
	EQualiteRepresentant: EQualiteRepresentantTrads,
	ECategorieSocialProfessionnel: ECategorieSocialProfessionnelTrads,
	ESubCategorisationMifCorporation: ESubCategorisationMifCorporationTrads,
	ESubStatutFactaCrsCorporation: ESubStatutFactaCrsCorporationTrads,
	ESubPeriodicitePiervalCorporation: ESubPeriodicitePiervalCorporationTrads,
	ESubPlacementPeuLiquiditeCorporation: ESubPlacementPeuLiquiditeCorporationTrads,
	ESubscriptionType: ESubscriptionTypeTrads,
	ESubDejaSouscritQuandCorporation: ESubDejaSouscritQuandCorporationTrads,
	ESubDejaSouscritCombienCorporation: ESubDejaSouscritCombienCorporationTrads,
	ESubDejaSouscritTypeCorporation: ESubDejaSouscritTypeCorporationTrads,
	ESubDejaSouscritPartCorporation: ESubDejaSouscritPartCorporationTrads,
	ESubFrequenceTransactionCorporation: ESubFrequenceTransactionCorporationTrads,
	ESubMoyenneTransactionCorporation: ESubMoyenneTransactionCorporationTrads,
	ESubModeGestionUtiliseCorporation: ESubModeGestionUtiliseCorporationTrads,
	ESubNbOperationsSansConseillerCorporation: ESubNbOperationsSansConseillerCorporationTrads,
	ESubRisqueRendementCorporation: ESubRisqueRendementCorporationTrads,
	ESubConnaissancesMarcheFinancierProduitsEpargneCorporation: ESubConnaissancesMarcheFinancierProduitsEpargneCorporationTrads,
	ESubCombienTempsRealisezInvestissementsCorporation: ESubCombienTempsRealisezInvestissementsCorporationTrads,
	ESubReactionChuteBrusqueValeurInvestissementCorporation: ESubReactionChuteBrusqueValeurInvestissementCorporationTrads,
	ESubConnaissancesMarcheImmobilierCorporation: ESubConnaissancesMarcheImmobilierCorporationTrads,
	EFundsOriginCorporation: EFundsOriginCorporationTrads,
	ESubSupportPlacementCorporation: ESubSupportPlacementCorporationTrads,
	ESubSupportPlacement: ESubSupportPlacementTrads,
	ESubOriginePatrimoineCorporation: ESubOriginePatrimoineCorporationTrads,
	EProductInformation: EProductInformationTrads,
	EProductFileType: EProductFileTypeTrads,
	EProductDocumentType: EProductDocumentTypeTrads,
	ESubDejaSouscritScpiPartPierval: ESubDejaSouscritScpiPartPiervalTrads,
	ESubDejaSouscritScpiPartPiervalCorporation: ESubDejaSouscritScpiPartPiervalCorporationTrads,
	EFundsOriginCommunityInvestment: EFundsOriginCommunityInvestmentTrads,
	EInvestorInvitationStatus: EInvestorInvitationStatusTrads,
	ETypePersonneJuridique: ETypePersonneJuridiqueTrads,
};

export default translations;
